

import cryptoJS from 'crypto-js';

const passkey = process.env.REACT_APP_STORAGE_ENCRYPT_KEY===undefined? "": process.env.REACT_APP_STORAGE_ENCRYPT_KEY.toString().padEnd(32, ' ');
//console.log('cryptoJS passkey', passkey);

export const getEncryptString = (value:string)=>{
    return cryptoJS.AES.encrypt(value, passkey, {
        iv: cryptoJS.enc.Utf8.parse(''),
        padding: cryptoJS.pad.Pkcs7,
        mode: cryptoJS.mode.CBC,
      }).toString();
}

export const getDecryptString = (value:string)=>{
    return cryptoJS.AES.decrypt(value, passkey, {
        iv: cryptoJS.enc.Utf8.parse(''),
        padding: cryptoJS.pad.Pkcs7,
        mode: cryptoJS.mode.CBC,
      }).toString(cryptoJS.enc.Utf8);
}



export const getDecryptObject = (value:string)=>{
  return JSON.parse(getDecryptString(value))
}


export const getEncryptObject = (obj:any)=>{
  return getEncryptString(JSON.stringify(obj))
}